export default (theme) => ({
    root: {
        position: 'relative',
        display: 'flex',
        flex: 0,
        padding: 8,
        justifyContent: 'space-between',
        '& .hoi-poi-select__dropdown-indicator': {
            display: 'flex !important',
        },
    },
    showMassiveToolbar: {
        '& $massiveToolbar': {
            top: 0,
            opacity: 1,
        },
    },
    massiveToolbar: {
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        top: -50,
        left: 0,
        padding: '20px 16px',
        opacity: 0,
        zIndex: 10,
        transition: 'all .3s ease-in-out',
        backgroundColor: '#fff',
        justifyContent: 'flex-start',
        width: '100%',
        '& svg': {
            verticalAlign: 'inherit',
        },
        '&:empty': {
            display: 'none',
        },
    },
    massiveCount: {
        marginRight: 8,
    },
    massiveCountNumber: {
        marginRight: 8,
    },
    massiveItems: {
        display: 'flex',
        alignItems: 'center',
        padding: '0 8px',
        '& svg': {
            verticalAlign: 'inherit',
        },
    },
    leftItems: {
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        '& svg': {
            verticalAlign: 'inherit',
        },
    },
    rightItems: {
        display: 'flex',
        alignItems: 'center',
        zIndex: 20,
        '& svg': {
            verticalAlign: 'inherit',
        },
    },
    item: {
        margin: '0 8px',
        display: 'flex',
        '& svg': {
            verticalAlign: 'inherit',
        },
    },
    itemFlexGrow: {
        flexGrow: 1,
    },
    massiveItem: {
        margin: '0 4px',
        display: 'flex',
        '& svg': {
            verticalAlign: 'inherit',
        },
    },
    withOptions: {
        minWidth: 350,
    },
    SectionToolbarSearch: {
        minWidth: 250,
    },
    typeOptionRow: {
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        color: 'inherit',
        width: '100%',
    },
    typeOptionRowRadio: {
        display: 'flex',
        alignItems: 'center',
    },
    typeOptionRowMainInfo: {
        marginLeft: 12,
        overflow: 'hidden',
    },
    typeOptionRowTitle: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontWeight: 500,
    },
    typeOptionRowInfo: {
        lineHeight: 13,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    clearSelection: {
        marginLeft: 8,
    },
});
